const Card = ({ src, title, description, className = "w-8 h-8", classNameTitle = "", isActive = false }) => {
    return (
        <div className="relative h-80 md:w-80 md:h-80 xl:w-64 xl:h-64 2xl:w-80 2xl:h-80">
            <div 
                className={`relative z-10 py-3  h-full pl-11 pt-11 text-[#FFFFFF] bg-[#212121] rounded-2xl peer xl:pl-8 xl:pt-8 2xl:pl-11 2xl:pt-11
                    ${isActive ? "hover-effect-active" : ""}
                `}
            >
                <img src={src} alt="img-landingpage" className={className} />
                <div className={`py-4 pr-16 text-xl xl:pr-10 xl:text-base 2xl:pr-20 2xl:text-xl ${classNameTitle}`}>
                    {title}
                </div>
                <div className="text-base pr-2 xl:pr-2 xl:text-sm 2xl:pr-14">
                    {description}
                </div>
            </div>
            <div 
                className={`absolute inset-0 rounded-2xl bg-[#5AE65E] transition-transform duration-1000 ease-in-out peer-hover:-rotate-2
                    ${isActive ? "-rotate-2" : ""}
                `}
            />
        </div>
    );
};

export default Card;
